import React, { useEffect, useState } from "react";
import { Box } from "@mui/joy";
import { FormGrid, FormField } from "../../FormGrid";
import { BillEntryPageProps } from "../../../utils/types";
import { billCategoryOptions, billTypeOptions, procurementTypeOptions } from "../../../utils/constants";
import { useGetPoListWithProcurementMutation } from "../../../services/vendor/VendorApi";
import { toast } from "react-toastify";

const billFormFields: FormField[] = [
  {
    name: "vendorName",
    label: "Vendor Name:",
    placeholder: "NA",
    type: "text",
    readOnly: true,
  },
  {
    name: "vendorCode",
    label: "Vendor Code:",
    placeholder: "NA",
    type: "text",
    readOnly: true,
  },
  {
    name: "poContract",
    label: "PO/Contract:",
    placeholder: "Enter PO number",
    type: "text",
    readOnly: true,
  },
  // {
  //   name: "grossAmount",
  //   label: "Base Amount:",
  //   type: "text",
  //   placeholder: "0.00",
  //   readOnly: true,
  // },
  // {
  //   name: "totalTax",
  //   label: "Total Tax:",
  //   type: "text",
  //   placeholder: "0.00",
  //   readOnly: true,
  // },
  // {
  //   name: "billAmount",
  //   label: "Invoice Amount:",
  //   type: "text",
  //   placeholder: "0.00",
  //   readOnly: true,
  // },

  // {
  //   name: "netPayable",
  //   label: "Net Payable:",
  //   type: "text",
  //   placeholder: "0.00",
  //   readOnly: true,
  // },
  {
    name: "billType",
    label: "Invoice Type:",
    type: "select",
    placeholder: "Select a type...",
    options: billTypeOptions,
    readOnly: true,
  },
  {
    name: "billCategory",
    label: "Invoice Category:",
    type: "select",
    readOnly: true,
    placeholder: "Select a category...",
    options: billCategoryOptions,
  },
  {
    name: "procurement_type",
    label: "Procurement Type",
    type: "select",
    readOnly: true,
    placeholder: "Select a procurement type...",
    options: procurementTypeOptions,
  },
  {
    name: "dakNo",
    label: "DAK No.:",
    type: "text",
    placeholder: "Enter DAK number",
    readOnly: true,
  },
  // {
  //   name: "billDate",
  //   label: "Invoice Date:",
  //   type: "date",
  //   readOnly: true,
  // },
  // {
  //   name: "challanNo",
  //   label: "Invoice No.:",
  //   placeholder: "Enter Challan number",
  //   readOnly: true,
  // },
  {
    name: "selectedpo",
    label: "Selected Po:",
    type: "H",
    placeholder: "Please select po",
    readOnly: false,
    options: [],
  },
  {
    name: "remarks",
    label: "Remarks:",
    type: "textarea",
    placeholder: "Enter remarks",
    readOnly: true,
    gridSpan: 4,
  },
];

export const BillEntryPage: React.FC<BillEntryPageProps> = ({ invoiceData, setDataApproverList, setHntValue }) => {

  const [getProcurementTypeData, { isLoading, isSuccess, isError }] = useGetPoListWithProcurementMutation();
  const [formData, setFormData] = useState({
    vendorName: invoiceData.vendor_name || "",
    vendorCode: invoiceData.vendor_code || "",
    poContract: invoiceData.po_contract || "",
    billCategory: invoiceData.bill_category || "",
    billType: invoiceData?.bill_type || "",
    dakNo: invoiceData.dak_no || "",
    grossAmount: invoiceData.gross_amount || "",
    totalTax: invoiceData.total_tax || "",
    billAmount: invoiceData.bill_amount || "",
    advanceAdjustment: invoiceData.advance_adj || "",
    billDate: invoiceData.bill_date || "",
    challanNo: invoiceData.bill_No || "",
    netPayable: invoiceData.net_payable || "",
    remarks: invoiceData.Remarks || "",
    procurement_type: invoiceData.procurement_type || "",
    hnt_value: invoiceData?.hnt_value || "",
    invoice_location: invoiceData?.invoice_location || "",
    division_name: invoiceData?.division_name || "",
    pending_with: invoiceData?.pending_with || "",
  });

  useEffect(() => {
    // Only update the form if invoiceData actually exists
    if (invoiceData) {
      setFormData({
        vendorName: invoiceData.vendor_name || "",
        vendorCode: invoiceData.vendor_code || "",
        poContract: invoiceData.po_contract || "",
        billCategory: invoiceData.bill_category || "",
        billType: invoiceData.bill_type || "",
        dakNo: invoiceData.dak_no || "",
        grossAmount: invoiceData.gross_amount || "",
        totalTax: invoiceData.total_tax || "",
        billAmount: invoiceData.bill_amount || "",
        advanceAdjustment: invoiceData.advance_adj || "",
        billDate: invoiceData.bill_date || "",
        challanNo: invoiceData.challan_no || "",
        netPayable: invoiceData.net_payable || "",
        remarks: invoiceData.Remarks || "", // Note: Mismatched case 'Remarks' vs 'remarks'
        procurement_type: invoiceData.procurement_type || "",
        hnt_value: invoiceData?.hnt_value || "",
        invoice_location: invoiceData?.invoice_location || "",
        division_name: invoiceData?.division_name || "",
        pending_with: invoiceData?.pending_with || "",
      });
      setHntValue(invoiceData?.hnt_value);
    }
  }, [invoiceData]);

  useEffect(() => {
    setHntValue(formData?.hnt_value);
  }, [formData]);

  async function getPoListData() {
    try {
      if (invoiceData.procurement_type) {
        const response: any = (await getProcurementTypeData({ vendorCode: invoiceData.vendor_code, procurementType: invoiceData.procurement_type })) || [];
        if (response["data"]) {
          const selectedPo = response["data"]?.find((po) => po.ebeln === invoiceData.po_contract) || null;

          var obj: any = {
            name: "invoice_location",
            label: "Invoice for which location?:",
            type: "text",
            placeholder: "",
            readOnly: true,
          }
          var obj1: any = {
            name: "division_name",
            label: "Division Name:",
            type: "text",
            placeholder: "",
            readOnly: true,
          }
          var obj2: any = {
            name: "pending_with",
            label: "Assign To:",
            type: "text",
            placeholder: "",
            readOnly: true,
          }
          if (billFormFields.length === 9) {

            billFormFields.splice(6, 0, obj);
            billFormFields.splice(7, 0, obj1);
            billFormFields.splice(8, 0, obj2);
            setFormData({ ...formData, invoice_location: selectedPo?.plant_code + " - " + selectedPo?.plant_name, division_name: selectedPo?.division_code + " - " + selectedPo?.division_name, pending_with: selectedPo?.responsible_person })
          }
        }
      }
    } catch (err) {
      let errorMessage = "An error occurred. " + (err?.data?.message || err?.message);
      toast.error(errorMessage);
    }
  }
  useEffect(() => {
    getPoListData();
  }, []);

  const handleFormChange = (name: string, value: string) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFormSubmit = (e: React.FormEvent) => {
    e.preventDefault();
  };

  return (
    <Box component="form" onSubmit={handleFormSubmit} sx={{ my: 2 }} style={{ marginTop: 0 }}>
      <FormGrid fields={billFormFields} formData={formData} onFormChange={handleFormChange} setDataApproverList={setDataApproverList} />
    </Box>
  );
};
